import * as React from 'react';
import { Field } from 'redux-form';
import { ChromePicker } from 'react-color';
import { compose, withState } from 'recompose';
import TextField from 'material-ui/TextField';

import { ColorPickerTypes, ColorPickerFieldType } from './_colorPickerTypes';

const enhance = compose<any, any>(withState('colorPickerVisible', 'toggleColorPicker', false));

const ComposedColorPicker: React.SFC<ColorPickerTypes> = ({
  input,
  label,
  meta: { error, submitFailed },
  bottomMargin = true,
  colorPickerVisible,
  toggleColorPicker,
  alwaysVisible = false,
  ...custom
}) => (
  <div style={{ position: 'relative', width: '100%' }}>
    <>
      <div
        style={{
          backgroundColor: input.value,
          position: 'absolute',
          right: 0,
          top: 34,
          width: 30,
          height: 20,
          border: '1px solid #000',
          zIndex: 69
        }}
        onClick={() => toggleColorPicker(true)}
      />
      <div onClick={() => toggleColorPicker(true)}>
        <TextField
          floatingLabelText={label}
          {...input}
          {...custom}
          errorText={submitFailed && error ? error : null}
          fullWidth={true}
        />
      </div>
      {colorPickerVisible || alwaysVisible ? (
        <div>
          <ChromePicker disableAlpha={true} color={input.value} onChange={(color: any) => input.onChange(color.hex)} />
        </div>
      ) : null}
    </>
  </div>
);

export const ColorPicker = enhance(ComposedColorPicker);

export class ColorPickerField extends Field<ColorPickerFieldType> {}



// WEBPACK FOOTER //
// ./src/components/form/ColorPicker/ColorPicker.tsx